export default __webpack_public_path__ + "static/media/mastercard.80b29296.svg";